// BARCINO — Quiz / Diagnostic café
// Navigation : boutons Précédent / Suivant (pas d'auto-avance)
// Scoring : accumulation des profile_scores au moment du clic SUIVANT

const barcinoDiagnostic = {

    _el: null,
    _cart_submitting: false,
    _photoLayers: [],    // 2 calques <picture> empilés — fondu croisé (voir _swapPhoto)
    _activeLayer: 0,
    _currentPhoto: '',   // évite un fondu inutile si la photo ne change pas
    _nav: null,
    _numEl: null,
    _steps: [],          // tous les [data-step] DOM nodes
    _questionSteps: [],  // seulement les steps questions (numéros 1..N)
    _totalQuestions: 0,
    _currentStep: 0,     // 0 = intro, 1..N = questions, 'result' = résultat
    _scores: {},         // { profile_id: total_score }
    _chosen: {},         // { stepNum: { answer_id, scores } } — une réponse par step
    _profils: [],
    _lang: 'fr',
    _baseUrl: '',
    _i18n: {},           // labels traduits via data-i18n-* sur #bc-quiz

    init() {
        this._el = document.getElementById('bc-quiz');
        if (!this._el) return;

        this._profils  = JSON.parse(this._el.dataset.quiz || '[]');
        this._lang     = this._el.dataset.lang || 'fr';
        this._baseUrl  = document.querySelector('base')?.href || window.location.origin + '/';
        this._i18n     = {
            add:          this._el.dataset.i18nAdd          || 'AJOUTER',
            added:        this._el.dataset.i18nAdded        || 'AJOUTÉ',
            from:         this._el.dataset.i18nFrom         || 'À partir de',
            more:         this._el.dataset.i18nMore         || 'AFFICHER PLUS',
            less:         this._el.dataset.i18nLess         || 'AFFICHER MOINS',
            profil:       this._el.dataset.i18nProfil       || 'Profil',
            composition:  this._el.dataset.i18nComposition  || 'Composition',
            intensite:    this._el.dataset.i18nIntensite    || 'Intensité',
            torrefaction: this._el.dataset.i18nTorrefaction || 'Torréfaction',
            acidite:      this._el.dataset.i18nAcidite      || 'Acidité',
        };
        this._photoLayers  = Array.from(this._el.querySelectorAll('[data-photo-layer]'));
        this._activeLayer  = this._photoLayers.findIndex(l => l.classList.contains('is-active'));
        if (this._activeLayer === -1) this._activeLayer = 0;
        this._currentPhoto = this._photoLayers[this._activeLayer]?.querySelector('[data-photo-img]')?.src || '';
        this._nav      = this._el.querySelector('.bc-quiz__nav');
        this._numEl    = document.getElementById('bc-quiz-num');

        this._steps          = Array.from(this._el.querySelectorAll('[data-step]'));
        this._questionSteps  = this._steps.filter(s => {
            const n = s.dataset.step;
            return n !== '0' && n !== 'result';
        });
        this._totalQuestions = this._questionSteps.length;

        this._profils.forEach(p => { this._scores[p.id] = 0; });

        this._bindEvents();
    },

    destroy() {},

    _bindEvents() {
        // Démarrer
        this._el.querySelector('[data-quiz-start]')?.addEventListener('click', () => {
            this._goToStep(1);
        });

        // Réponses boutons — sélection uniquement (pas d'avance auto)
        this._el.querySelectorAll('[data-answer-id]').forEach(btn => {
            btn.addEventListener('click', () => this._onAnswer(btn));
        });

        // Sliders — pré-initialisation + écoute
        this._el.querySelectorAll('[data-slider-input]').forEach(input => {
            input.addEventListener('input', () => this._onSlider(input));
            this._onSlider(input); // init au chargement (position centrale)
        });

        // Navigation
        this._el.querySelector('[data-quiz-prev]')?.addEventListener('click', () => this._prev());
        this._el.querySelector('[data-quiz-next]')?.addEventListener('click', () => this._next());

        this._el.querySelector('[data-result-cart-cta]')?.addEventListener('click', () => this._submitCart());

        // Recommencer
        this._el.querySelector('[data-quiz-restart]')?.addEventListener('click', () => this._restart());
    },

    _onSlider(input) {
        const stepEl  = input.closest('[data-step]');
        const stepNum = parseInt(stepEl.dataset.step, 10);
        const answers = JSON.parse(input.dataset.answers || '[]');
        const idx     = parseInt(input.value, 10);
        const ans     = answers[idx];
        if (!ans) return;

        // Description centrée au-dessus du curseur (champ answer_description)
        const descEl = stepEl.querySelector('[data-slider-desc]');
        if (descEl) descEl.textContent = ans.answer_description || '';

        // Remplissage visuel — calcul sur la largeur du rail (track - padding)
        const fillEl = stepEl.querySelector('[data-slider-fill]');
        if (fillEl) {
            const pct      = parseInt(input.max, 10) > 0 ? (idx / parseInt(input.max, 10)) * 100 : 0;
            const trackEl  = input.closest('.bc-quiz__slider-track');
            const pl       = parseFloat(getComputedStyle(trackEl).paddingLeft);
            const pr       = parseFloat(getComputedStyle(trackEl).paddingRight);
            const railW    = trackEl.offsetWidth - pl - pr;
            fillEl.style.width = (pct / 100 * railW) + 'px';
        }

        // Stocker le choix pour la validation SUIVANT
        this._chosen[stepNum] = {
            answer_id: ans.id,
            scores: ans.profile_scores || {},
        };
    },

    _goToStep(n) {
        this._steps.forEach(s => s.classList.remove('is-active'));
        const target = this._steps.find(s => s.dataset.step == n);
        if (target) {
            target.classList.add('is-active');
            this._currentStep = n;
        }

        // Mode résultat : photo masquée, overlay plein écran
        this._el.classList.toggle('bc-quiz--result', n === 'result');

        // Photo gauche — fondu croisé si le step a data-step-photo
        if (target?.dataset.stepPhoto) {
            this._swapPhoto(target.dataset.stepPhoto, target.dataset.stepPhotoWebp);
        }

        // Navigation — visible seulement sur les steps questions
        const isQuestion = n !== 0 && n !== '0' && n !== 'result';
        if (this._nav) {
            this._nav.hidden = !isQuestion;
        }

        // Compteur et état du bouton Précédent
        if (isQuestion) {
            const num = parseInt(n, 10);
            if (this._numEl) {
                this._numEl.textContent = String(num).padStart(2, '0');
            }
            const prevBtn = this._el.querySelector('[data-quiz-prev]');
            if (prevBtn) prevBtn.disabled = (num <= 1);
        }
    },

    // Fondu croisé entre les deux calques photo. Le nouveau visuel est chargé
    // dans le calque caché avant d'être révélé — jamais de flash ni de saut brut.
    _swapPhoto(url, webpUrl) {
        if (!url || url === this._currentPhoto || !this._photoLayers.length) return;
        this._currentPhoto = url;

        const nextIndex = 1 - this._activeLayer;
        const nextLayer = this._photoLayers[nextIndex];
        const currentLayer = this._photoLayers[this._activeLayer];
        if (!nextLayer) return;

        const img    = nextLayer.querySelector('[data-photo-img]');
        const source = nextLayer.querySelector('[data-photo-source]');
        if (img) img.src = url;
        if (source) source.srcset = webpUrl || url;

        nextLayer.classList.add('is-active');
        currentLayer?.classList.remove('is-active');
        this._activeLayer = nextIndex;
    },

    _onAnswer(btn) {
        const stepEl  = btn.closest('[data-step]');
        const stepNum = parseInt(stepEl.dataset.step, 10);

        // Désélectionne les autres réponses du même step
        stepEl.querySelectorAll('[data-answer-id]').forEach(b => b.classList.remove('is-selected'));
        btn.classList.add('is-selected');

        // Stocke le choix (sans accumuler encore — on accumule au SUIVANT)
        this._chosen[stepNum] = {
            answer_id: btn.dataset.answerId,
            scores: JSON.parse(btn.dataset.scores || '{}'),
        };
    },

    _next() {
        const n = parseInt(this._currentStep, 10);
        if (isNaN(n)) return;

        // Vérifie qu'une réponse est sélectionnée sur ce step
        if (!this._chosen[n]) return; // pas de réponse → on ne peut pas avancer

        if (n >= this._totalQuestions) {
            this._computeScores();
            this._showResult();
        } else {
            this._goToStep(n + 1);
        }
    },

    _prev() {
        const n = parseInt(this._currentStep, 10);
        if (isNaN(n) || n <= 1) return;
        this._goToStep(n - 1);
    },

    _computeScores() {
        // Réinitialise et recalcule depuis _chosen
        this._profils.forEach(p => { this._scores[p.id] = 0; });

        Object.values(this._chosen).forEach(({ scores }) => {
            Object.entries(scores).forEach(([profileId, val]) => {
                if (this._scores[profileId] !== undefined) {
                    this._scores[profileId] += Number(val);
                }
            });
        });
    },

    _showResult() {
        let winnerId = null;
        let maxScore = -1;

        Object.entries(this._scores).forEach(([id, score]) => {
            if (score > maxScore) { maxScore = score; winnerId = id; }
        });

        const winner = this._profils.find(p => p.id === winnerId);

        if (winner) {
            const nameEl  = this._el.querySelector('[data-result-name]');
            const descEl  = this._el.querySelector('[data-result-desc]');
            const prodsEl = this._el.querySelector('[data-result-products]');

            if (nameEl) nameEl.textContent = winner.name || '';
            if (descEl) descEl.textContent = winner.description || '';

            if (prodsEl && winner.products?.length) {
                prodsEl.innerHTML = winner.products.map(p => this._buildProductCard(p)).join('');

                // Sélection variante
                prodsEl.querySelectorAll('[data-variant-pill]').forEach(pill => {
                    pill.addEventListener('click', () => this._selectVariant(pill));
                });

                // Présélectionner 1 kg, sinon le premier format proposé.
                // Réutiliser la sélection pour synchroniser prix et bouton Ajouter.
                prodsEl.querySelectorAll('.bc-quiz__rp-card').forEach(card => {
                    const default_variant = card.querySelector('[data-variant-pill][data-weight="1000"]')
                        || card.querySelector('[data-variant-pill]');
                    if (default_variant) this._selectVariant(default_variant);
                });

                // Sélection produit (toggle)
                prodsEl.querySelectorAll('[data-add-to-cart]').forEach(btn => {
                    btn.addEventListener('click', () => this._toggleProduct(btn));
                });

                // Expand détails
                prodsEl.querySelectorAll('[data-expand]').forEach(btn => {
                    btn.addEventListener('click', () => this._toggleExpand(btn));
                });
            }

            // Gros bouton CTA → envoie tous les sélectionnés au panier

            this._updateCartCta();
        }

        if (winnerId) this._saveResult(winnerId);
        this._goToStep('result');
    },

    _buildProductCard(p) {
        const img = p.img?.medium
            ? `<picture>
                ${p.img.medium_webp ? `<source srcset="${p.img.medium_webp}" type="image/webp">` : ''}
                <img src="${p.img.medium}" alt="${this._esc(p.name)}" class="bc-quiz__rp-img" loading="lazy">
               </picture>`
            : `<span class="bc-quiz__rp-img bc-quiz__rp-img--empty"></span>`;

        const metaParts = [p.roaster_name, this._grindLabel(p.grind_type)].filter(Boolean);
        const meta = metaParts.length ? `<p class="bc-quiz__rp-meta">${metaParts.join(' • ')}</p>` : '';

        // Seules les variantes avec un poids réel comptent — un produit en vente
        // directe peut avoir une "variante" fantôme sans grammage (weight_grams null).
        const weightedVariants = (p.variants || []).filter(v => v.weight_grams);
        const firstVariant = weightedVariants[0];
        const priceFrom    = p.price_from ?? p.base_price;
        const priceKiloFrom = firstVariant?.weight_grams
            ? this._formatPrice(firstVariant.price / (firstVariant.weight_grams / 1000)) + '/kg'
            : '';

        const pills = weightedVariants.map((v) => {
            const label = v.weight_grams >= 1000 ? (v.weight_grams / 1000) + ' kg' : v.weight_grams + ' g';
            return `<button class="bc-quiz__rp-weight" type="button"
                            data-variant-pill data-product-id="${p.id}"
                            data-variant-id="${v.id}" data-price="${v.price}" data-old-price="${v.old_price ?? ''}" data-weight="${v.weight_grams}">${label}</button>`;
        }).join('');

        const desc = p.short_description
            ? `<p class="bc-quiz__rp-desc">${this._esc(p.short_description)}</p>` : '';

        // Chips aromatiques (flavor_tags)
        const chips = (p.flavor_tags || []).map(t =>
            `<span class="bc-quiz__rp-chip">${this._esc(t)}</span>`
        ).join('');
        const chipsHtml = chips ? `<div class="bc-quiz__rp-chips">${chips}</div>` : '';

        // Bloc détails expandable
        const hasDetails = p.grind_type || p.arabica_pct || p.intensity_level || p.torrefaction_level || p.acidity_level;
        const detailsHtml = hasDetails ? `
            <div class="bc-quiz__rp-details" hidden>
                <div class="bc-quiz__rp-specs">
                    <div class="bc-quiz__rp-specs-left">
                        ${p.grind_type   ? `<div class="bc-quiz__rp-spec"><span class="bc-quiz__rp-spec-label">${this._i18n.profil}</span><span class="bc-quiz__rp-spec-val">${this._esc(this._grindLabel(p.grind_type) || p.grind_type)}</span></div>` : ''}
                        ${p.arabica_pct  ? `<div class="bc-quiz__rp-spec"><span class="bc-quiz__rp-spec-label">${this._i18n.composition}</span><span class="bc-quiz__rp-spec-val">${this._esc(p.arabica_pct)}</span></div>` : ''}
                    </div>
                    <div class="bc-quiz__rp-specs-right">
                        ${p.intensity_level    ? `<div class="bc-quiz__rp-spec bc-quiz__rp-spec--bar"><span class="bc-quiz__rp-spec-label">${this._i18n.intensite}</span>${this._buildBars(p.intensity_level, 4)}</div>` : ''}
                        ${p.torrefaction_level ? `<div class="bc-quiz__rp-spec bc-quiz__rp-spec--bar"><span class="bc-quiz__rp-spec-label">${this._i18n.torrefaction}</span>${this._buildBars(p.torrefaction_level)}</div>` : ''}
                        ${p.acidity_level      ? `<div class="bc-quiz__rp-spec bc-quiz__rp-spec--bar"><span class="bc-quiz__rp-spec-label">${this._i18n.acidite}</span>${this._buildBars(p.acidity_level)}</div>` : ''}
                    </div>
                </div>
            </div>` : '';

        const addLabel = this._i18n.add;

        return `<div class="bc-quiz__rp-card" data-product-id="${p.id}">
            <div class="bc-quiz__rp-thumb">${img}</div>
            <div class="bc-quiz__rp-info">
                <div class="bc-quiz__rp-head">
                    <div>
                        <h4 class="bc-quiz__rp-name">${this._esc(p.name)}</h4>
                        ${meta}
                    </div>
                    <div class="bc-quiz__rp-price-wrap">
                        <span class="bc-quiz__rp-price-label" data-product-price-label>${firstVariant ? this._i18n.from : ''}</span>
                        <del class="bc-quiz__rp-price-old" data-product-old-price ${p.old_price ? '' : 'hidden'}>${p.old_price ? this._formatPrice(p.old_price) : ''}</del>
                        <span class="bc-quiz__rp-price${p.old_price ? ' is-promo' : ''}" data-product-price>${this._formatPrice(priceFrom)}</span>
                        ${priceKiloFrom ? `<span class="bc-quiz__rp-price-kilo" data-product-price-kilo>${priceKiloFrom}</span>` : ''}
                    </div>
                </div>
                ${chipsHtml}
                ${desc}
                ${detailsHtml}
                ${hasDetails ? `<button class="bc-quiz__rp-expand" type="button" data-expand>${this._i18n.more}</button>` : ''}
                <div class="bc-quiz__rp-foot">
                    <div class="bc-quiz__rp-weights">${pills}</div>
                    <button class="bc-quiz__rp-add __btn _primary _sm" type="button"
                            data-add-to-cart
                            data-product-id="${p.id}"
                            data-variant-id="${this._esc(p.variants?.[0]?.id || '')}"
                            data-price="${firstVariant ? '' : priceFrom}"
                            data-added="0"
                            ${firstVariant ? 'disabled' : ''}>${addLabel}</button>
                </div>
            </div>
        </div>`;
    },

    _buildBars(level, max = 5) {
        let html = '<span class="bc-quiz__rp-bars">';
        for (let i = 1; i <= max; i++) {
            html += `<span class="bc-quiz__rp-bar${i <= level ? ' is-on' : ''}"></span>`;
        }
        return html + '</span>';
    },

    _toggleExpand(btn) {
        const card    = btn.closest('.bc-quiz__rp-card');
        const details = card?.querySelector('.bc-quiz__rp-details');
        if (!details) return;
        const isOpen = details.hidden === false;
        details.hidden = isOpen;
        btn.textContent = isOpen ? this._i18n.more : this._i18n.less;
    },

    _grindLabel(type) {
        const map = { grains: 'Grains', grossiere: 'Mouture grossière', moyenne: 'Moulu', fine: 'Mouture fine', tres_fine: 'Mouture très fine' };
        return map[type] || '';
    },

    _formatPrice(price) {
        return Number(price).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
    },

    _selectVariant(pill) {
        const productId = pill.dataset.productId;
        const card = this._el.querySelector(`.bc-quiz__rp-card[data-product-id="${productId}"]`);
        if (!card) return;

        // Activer la pill sélectionnée
        card.querySelectorAll('[data-variant-pill]').forEach(p => p.classList.remove('is-active'));
        pill.classList.add('is-active');

        // Mettre à jour le prix affiché — une fois un poids choisi, plus de "à partir de"
        const priceEl  = card.querySelector('[data-product-price]');
        const labelEl  = card.querySelector('[data-product-price-label]');
        const kiloEl   = card.querySelector('[data-product-price-kilo]');
        if (priceEl) {
            priceEl.textContent = this._formatPrice(pill.dataset.price);
            priceEl.classList.toggle('is-promo', Boolean(pill.dataset.oldPrice));
        }
        const old_price_el = card.querySelector('[data-product-old-price]');
        if (old_price_el) {
            old_price_el.hidden = !pill.dataset.oldPrice;
            old_price_el.textContent = pill.dataset.oldPrice ? this._formatPrice(pill.dataset.oldPrice) : '';
        }
        if (labelEl) labelEl.textContent = '';
        if (kiloEl) {
            const weight = Number(pill.dataset.weight || 0);
            kiloEl.textContent = weight
                ? this._formatPrice(Number(pill.dataset.price) / (weight / 1000)) + '/kg'
                : '';
        }

        // Mettre à jour le variant-id et le prix du bouton Ajouter — l'activer
        const addBtn = card.querySelector('[data-add-to-cart]');
        if (addBtn) {
            addBtn.dataset.variantId = pill.dataset.variantId;
            addBtn.dataset.price     = pill.dataset.price;
            addBtn.disabled = false;
            // Si déjà ajouté, on remet à zéro
            addBtn.dataset.added = '0';
            addBtn.classList.remove('is-added');
            addBtn.textContent = this._i18n.add;
        }

        this._updateCartCta();
    },

    // Toggle sélection d'un produit — ne touche pas encore au panier
    _toggleProduct(btn) {
        const isAdded = btn.dataset.added === '1';
        if (isAdded) {
            btn.dataset.added = '0';
            btn.classList.remove('is-added');
            btn.textContent = this._i18n.add;
        } else {
            btn.dataset.added = '1';
            btn.classList.add('is-added');
            btn.innerHTML = `${this._i18n.added} <span class="bc-quiz__rp-check">✓</span>`;
        }
        this._updateCartCta();
    },

    // Envoi en panier de tous les produits sélectionnés
    async _submitCart() {
        if (this._cart_submitting) return;
        const selected = Array.from(this._el.querySelectorAll('[data-add-to-cart][data-added="1"]'));
        if (!selected.length) return;

        const cta_btn = this._el.querySelector('[data-result-cart-cta]');
        this._cart_submitting = true;
        if (cta_btn) cta_btn.disabled = true;

        try {
            // Sérialiser les ajouts pour conserver la même session panier.
            for (const btn of selected) {
                const variant_id = btn.dataset.variantId;
                if (!variant_id) throw new Error(this._el.dataset.i18nCartError);
                const response = await fetch(`${this._baseUrl}${this._lang}/panier/ajouter`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest',
                    },
                    body: JSON.stringify({ variant_id, quantity: 1 }),
                });
                if (!response.ok) throw new Error(this._el.dataset.i18nCartError);
                const result = await response.json();
                if (!result.success) throw new Error(this._el.dataset.i18nCartError);

                // Ne pas renvoyer les ajouts confirmés lors d'une reprise après erreur.
                btn.dataset.added = '0';
                btn.classList.remove('is-added');
                btn.textContent = this._i18n.add;
            }
            window.location.href = `${this._baseUrl}${this._lang}/panier`;
        } catch (error) {
            this._updateCartCta();
            window.alert(this._el.dataset.i18nCartError);
        } finally {
            this._cart_submitting = false;
            if (cta_btn) cta_btn.disabled = false;
        }
    },

    _updateCartCta() {
        const footerEl = this._el.querySelector('[data-result-footer]');
        const totalEl  = this._el.querySelector('[data-cart-total]');
        if (!footerEl || !totalEl) return;

        const added = Array.from(this._el.querySelectorAll('[data-add-to-cart][data-added="1"]'));

        if (added.length === 0) {
            footerEl.hidden = true;
            return;
        }

        const total = added.reduce((sum, btn) => {
            const card       = btn.closest('.bc-quiz__rp-card');
            const activePill = card?.querySelector('[data-variant-pill].is-active');
            return sum + Number(activePill?.dataset.price || btn.dataset.price || 0);
        }, 0);

        totalEl.textContent = this._formatPrice(total);
        footerEl.hidden = false;
    },

    _saveResult(profileId) {
        const answers = Object.values(this._chosen).map(c => c.answer_id);
        const csrfCookie = document.cookie.split(';').find(c => c.trim().startsWith('csrf_cookie_barcino='));
        const csrfToken  = csrfCookie ? csrfCookie.split('=')[1].trim() : '';

        const body = new FormData();
        body.append('profile_id', profileId);
        body.append('answers', JSON.stringify(answers));
        body.append('csrf_token_barcino', csrfToken);

        fetch(`${this._baseUrl}${this._lang}/diagnostic/submit`, { method: 'POST', body }).catch(() => {});
    },

    _restart() {
        this._chosen = {};
        this._scores = {};
        this._profils.forEach(p => { this._scores[p.id] = 0; });
        this._el.querySelectorAll('[data-answer-id]').forEach(b => b.classList.remove('is-selected'));
        this._el.querySelectorAll('[data-slider-input]').forEach(input => {
            input.value = 0;
            this._onSlider(input);
        });
        this._goToStep(0);
    },

    _esc(str) {
        return String(str)
            .replace(/&/g, '&amp;').replace(/</g, '&lt;')
            .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    },
};

export default barcinoDiagnostic;
